import axios from 'axios';

const BASE_URL = '/api/ts';

interface LoginResponse {
  token: string;
}

interface User {
  email: string;
  name: string;
  password: string;
}

export class AuthService {
  static async login(email: string, password: string): Promise<LoginResponse> {
    try {
      const response = await axios.post(
        `${BASE_URL}/login`,
        { email, password },
        {
          headers: { 'Content-Type': 'application/json' },
        },
      );

      const token = response.headers['x-auth'];
      if (!token) {
        throw new Error('Token not provided by the server');
      }

      return { token };
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || 'Login failed';
      throw new Error(errorMessage);
    }
  }

  static async register(user: User): Promise<void> {
    try {
      await axios.post(`${BASE_URL}/register`, user, {
        headers: { 'Content-Type': 'application/json' },
      });
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || 'Registration failed';
      throw new Error(errorMessage);
    }
  }
}
